/** data-testid used for quickly finding elements on automated tests */
/** data-test-id comes from external library. Naming convention not followed.*/
export const qaLabelTeams = {
    newTeamButton: 'teams--new-team-button',
    newDashboardUserButton: 'teams--new-dashboard-user-button',
    newDriverButton: 'teams--new-driver-button',
    editTeamButton: 'teams--edit-team-button',
    newTeamModal: {
        title: 'teams--new-team-modal--title',
        nameInput: 'teams--new-team-modal--name-input',
        saveTeam: 'teams--new-team-modal--save-button',
        parentGroupDropdown: 'teams--new-team-modal--parent-group-dropdown'
    },
    editTeamModal: {
        title: 'teams--edit-team-modal--title',
        newNameInput: 'teams--edit-team-modal--new-name-input',
        saveEditedTeam: 'teams--edit-team-modal--save-button'
    },
    teamDetailsNameTitle: 'teams--team-details--name-title',
    teamGroupItem: 'teams--team-list--team-item',
    teamDeleteIcon: 'teams--delete-button',
    // User modal
    newDashboardUserModal: {
        title: 'teams--new-user-modal--title',
        emailInput: 'teams--new-user-modal--email-input',
        roleDropdown: 'teams--new-user-modal--role-dropdown',
        groupDropdown: 'teams--new-user-modal--group-dropdown',
        saveButton: 'teams--new-user-modal--save-btn',
        cancelButton: 'teams--new-user-modal--cancel-btn'
    },
    // Dashboard users list
    userRow: '[data-testid=teams--user-list] > tbody > tr',
    userRowPrefix: 'teams--user-row',
    userRowSaveButton: 'teams--user-row-actions-save-btn',
    userRowCancelBtn: 'teams--user-row-actions-cancel-btn',
    userRowEmailText: 'teams--user-row-email-btn',
    userRowRoleText: 'teams--user-row-position-text',
    userRowRoleDropdown: 'teams--user-row-position-dropdown',
    userRowNameText: 'teams--user-row-name-text',
    userRowImage: 'teams--user-row-image',
    userRowDeleteButton: 'teams--user-delete-btn',
    // Drivers list
    driversNumber: 'teams--driver--header-number',
    driverRow: '[data-testid=teams--driver-list] > tbody > tr',
    driverTable: '[data-testid=teams--driver-row-name] > tbody',
    driverRowPrefix: 'teams--driver-row',
    driverRowSaveButton: 'teams--driver-row-actions-save',
    driverRowCancelBtn: 'teams--driver-row-actions-cancel',
    driverRowExternalIdRow: 'teams--driver-row-external-id',
    driverRowExternalIdInput: 'teams--driver-row-external-id-input',
    driverRowEmailText: 'teams--driver-row-email',
    driverRowPhoneText: 'teams--driver-row-phone',
    driverRowGroupRow: 'teams--driver-row-team',
    driverRowGroupDropdown: 'teams--driver-row-group-dropdown',
    driverRowNameText: 'teams--driver-row-name',
    driverRowImage: 'teams--driver-row-image',
    driverRowDeleteButton: 'teams--driver-delete-button',
    // Driver modal
    newDriverModal: {
        title: 'teams--new-driver-modal--title',
        emailInput: 'teams--new-driver-modal--email-input',
        drivingForInput: 'teams--new-driver-modal--driving-for-input',
        groupDropdown: 'teams--new-driver-modal--group-dropdown',
        externalIdentifierInput: 'teams--new-driver-modal--external-identifier-input',
        addDriverButton: 'teams--new-driver-modal--save-btn',
        cancelButton: 'teams--new-driver-modal--cancel-btn'
    }
};
